var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"base-icon",attrs:{"width":_vm.iconWidth,"height":_vm.iconHeight,"viewBox":_vm.icon.viewBox,"fill":"currentColor"}},_vm._l((_vm.paths),function(path){return _c('path',{attrs:{"d":path}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }